var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "div",
            { staticClass: "d-flex justify-content-end" },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-modal",
                      rawName: "v-b-modal.modal-main",
                      modifiers: { "modal-main": true },
                    },
                  ],
                  staticClass: "my-1",
                  attrs: { variant: "primary" },
                },
                [_vm._v(" Add Warehouse ")]
              ),
            ],
            1
          ),
          _c(
            "b-modal",
            {
              attrs: {
                id: "modal-main",
                "cancel-variant": "outline-secondary",
                centered: "",
                title: "Add Warehouse",
                "hide-footer": "",
              },
            },
            [
              _c(
                "validation-observer",
                { ref: "AddWarehouseForm" },
                [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.AddWarehouse($event)
                        },
                      },
                    },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c("label", { attrs: { for: "email" } }, [
                            _vm._v("Warehouse Name*"),
                          ]),
                          _c("validation-provider", {
                            attrs: {
                              name: "Type",
                              vid: "Type",
                              rules: "required",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "Type",
                                        type: "text",
                                        placeholder: "Warehouse Name",
                                      },
                                      model: {
                                        value: _vm.warehouseName,
                                        callback: function ($$v) {
                                          _vm.warehouseName = $$v
                                        },
                                        expression: "warehouseName",
                                      },
                                    }),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-form-group",
                        [
                          _c("label", { attrs: { for: "email" } }, [
                            _vm._v("Address*"),
                          ]),
                          _c("validation-provider", {
                            attrs: {
                              name: "Address",
                              vid: "Address",
                              rules: "required",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "Address",
                                        type: "text",
                                        placeholder: "Address",
                                      },
                                      model: {
                                        value: _vm.warehouseAddress,
                                        callback: function ($$v) {
                                          _vm.warehouseAddress = $$v
                                        },
                                        expression: "warehouseAddress",
                                      },
                                    }),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "modal-footer" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.AddWarehouse()
                              },
                            },
                          },
                          [
                            _vm.loading
                              ? _c("b-spinner", {
                                  staticClass: "mx-2",
                                  attrs: { small: "" },
                                })
                              : _vm._e(),
                            _vm._v("Add "),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-modal",
            {
              attrs: {
                id: "modal-edit",
                "cancel-variant": "outline-secondary",
                centered: "",
                title: "Edit Warehouse",
                "hide-footer": "",
              },
            },
            [
              _c(
                "validation-observer",
                { ref: "EditWarehouseForm" },
                [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.EditWarehouse($event)
                        },
                      },
                    },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c("label", { attrs: { for: "email" } }, [
                            _vm._v("Warehouse Name*"),
                          ]),
                          _c("validation-provider", {
                            attrs: {
                              name: "Type",
                              vid: "Type",
                              rules: "required",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "Type",
                                        type: "text",
                                        placeholder: "Warehouse Name",
                                      },
                                      model: {
                                        value: _vm.editWarehouseData.name,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.editWarehouseData,
                                            "name",
                                            $$v
                                          )
                                        },
                                        expression: "editWarehouseData.name",
                                      },
                                    }),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-form-group",
                        [
                          _c("label", { attrs: { for: "email" } }, [
                            _vm._v("Address*"),
                          ]),
                          _c("validation-provider", {
                            attrs: {
                              name: "address",
                              vid: "address",
                              rules: "required",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "address",
                                        type: "text",
                                        placeholder: "Address",
                                      },
                                      model: {
                                        value: _vm.editWarehouseData.address,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.editWarehouseData,
                                            "address",
                                            $$v
                                          )
                                        },
                                        expression: "editWarehouseData.address",
                                      },
                                    }),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "modal-footer" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button", block: "" },
                            on: {
                              click: function ($event) {
                                return _vm.EditWarehouse()
                              },
                            },
                          },
                          [
                            _vm.loading
                              ? _c("b-spinner", {
                                  staticClass: "mx-2",
                                  attrs: { small: "" },
                                })
                              : _vm._e(),
                            _vm._v("Edit "),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { staticClass: "my-1", attrs: { cols: "12", md: "2", sm: "2" } },
        [
          _c(
            "b-form-group",
            { staticClass: "mb-0" },
            [
              _c(
                "label",
                { staticClass: "d-inline-block text-sm-left mr-50" },
                [_vm._v("Per page")]
              ),
              _c("b-form-select", {
                attrs: {
                  id: "perPageSelect",
                  size: "sm",
                  options: _vm.pageOptions,
                },
                model: {
                  value: _vm.perPage,
                  callback: function ($$v) {
                    _vm.perPage = $$v
                  },
                  expression: "perPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        {
          staticClass: "d-flex justify-content-end mb-2",
          attrs: { cols: "12" },
        },
        [
          _c(
            "b-button",
            {
              attrs: {
                variant: "outline-danger",
                disabled: !_vm.anyFilterActive,
              },
              on: { click: _vm.clearFilters },
            },
            [_vm._v(" Clear Filters ")]
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-table", {
            attrs: {
              striped: "",
              hover: "",
              responsive: "",
              "per-page": _vm.perPage,
              "current-page": _vm.currentPage,
              items: _vm.filteredWarehouses,
              fields: _vm.fields,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc,
              "sort-direction": _vm.sortDirection,
            },
            on: {
              "update:sortBy": function ($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function ($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function ($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function ($event) {
                _vm.sortDesc = $event
              },
              filtered: _vm.onFiltered,
            },
            scopedSlots: _vm._u([
              {
                key: "head(name)",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Warehouse Name")]),
                        _c("b-form-input", {
                          attrs: {
                            placeholder: "Filter by Warehouse Name",
                            size: "sm",
                          },
                          on: { input: _vm.filterTable },
                          model: {
                            value: _vm.filters.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "name", $$v)
                            },
                            expression: "filters.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "head(address)",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Address")]),
                        _c("b-form-input", {
                          attrs: {
                            placeholder: "Filter by Address",
                            size: "sm",
                          },
                          on: { input: _vm.filterTable },
                          model: {
                            value: _vm.filters.address,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "address", $$v)
                            },
                            expression: "filters.address",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "cell(name)",
                fn: function (data) {
                  return [_vm._v(" " + _vm._s(data.item.name) + " ")]
                },
              },
              {
                key: "cell(address)",
                fn: function (data) {
                  return [_vm._v(" " + _vm._s(data.item.address) + " ")]
                },
              },
              {
                key: "cell(products)",
                fn: function (data) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.getTotalProducts(data.item.itemBalance)) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "cell(stock)",
                fn: function (data) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.getTotalStock(data.item.itemBalance)) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "cell(actions)",
                fn: function (data) {
                  return [
                    _c(
                      "b-dropdown",
                      {
                        attrs: {
                          variant: "link",
                          "toggle-class": "text-decoration-none",
                          "no-caret": "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "button-content",
                              fn: function () {
                                return [
                                  _c("feather-icon", {
                                    staticClass: "text-body align-middle mr-25",
                                    attrs: {
                                      icon: "MoreVerticalIcon",
                                      size: "16",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c(
                          "b-dropdown-item",
                          {
                            attrs: {
                              to: {
                                path:
                                  "/warehouse/warehouse-view/" + data.item.id,
                              },
                            },
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: { icon: "EyeIcon" },
                            }),
                            _c("span", [_vm._v("View")]),
                          ],
                          1
                        ),
                        _c(
                          "b-dropdown-item",
                          {
                            directives: [
                              {
                                name: "b-modal",
                                rawName: "v-b-modal.modal-edit",
                                modifiers: { "modal-edit": true },
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.getWarehouseData(data.item)
                              },
                            },
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: { icon: "Edit2Icon" },
                            }),
                            _c("span", [_vm._v("Edit")]),
                          ],
                          1
                        ),
                        _c(
                          "b-dropdown-item",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.removeWarehouse(data.item.id)
                              },
                            },
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: { icon: "TrashIcon" },
                            }),
                            _c("span", [_vm._v("Delete")]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c(
            "div",
            { staticClass: "d-flex justify-content-center mb-1" },
            [
              _vm.loading
                ? _c("b-spinner", {
                    staticStyle: { width: "3rem", height: "3rem" },
                    attrs: { variant: "success", label: "Spinning", block: "" },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-pagination", {
            staticClass: "my-0",
            attrs: {
              "total-rows": _vm.totalRows,
              "per-page": _vm.perPage,
              align: "center",
              size: "sm",
            },
            model: {
              value: _vm.currentPage,
              callback: function ($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage",
            },
          }),
          _c("b-form-group", [
            _vm._v(
              " Showing " +
                _vm._s(
                  _vm.totalRows > 0
                    ? _vm.perPage * (_vm.currentPage - 1) + 1
                    : 0
                ) +
                " to " +
                _vm._s(
                  _vm.totalRows > 0
                    ? Math.min(_vm.perPage * _vm.currentPage, _vm.totalRows)
                    : 0
                ) +
                " of " +
                _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                " entries "
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }